
export const routes = (prefix = `suppliers-dashboard`) => [
    {
        path: `/${prefix}/purchase-orders`,
        name: `${prefix}.purchase-orders.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.purchase-orders.index`,
                PageDescription: "Supplier Module: Purchase orders",
            },
        },
    },
    // {
    //     path: `/${prefix}/purchase-orders/create`,
    //     name: `${prefix}.purchase-orders.create`,
    //     component: () => import('./Form.vue'),
    //     meta: {
    //         requiresAuth: true,
    //         permissions: {
    //             PageName: `${prefix}.purchase-orders.index`,
    //             PageDescription: "Supplier Module: Purchase orders",
    //         },
    //     },
    // },
    {
        path: `/${prefix}/purchase-orders/create/:lpoNo`,
        name: `${prefix}.purchase-orders.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.purchase-orders.index`,
                PageDescription: "Supplier Module: Purchase orders",
            },
        },
    },
    {
        path: `/${prefix}/purchase-orders/view/:LPONo`,
        name: `${prefix}.purchase-orders.view`,
        component: () => import('./View.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.purchase-orders.index`,
                PageDescription: "Supplier Module: Purchase orders",
            },
        },
    },
    {
        path: `/${prefix}/purchase-orders/print/:LPONo`,
        name: `${prefix}.purchase-orders.print`,
        component: () => import('./Print.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.purchase-orders.index`,
                PageDescription: "Supplier Module: Purchase orders",
            },
        },
    },
];
